import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Typography,
  IconButton,
  Alert,
  CircularProgress
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const SignUp = ({ open, onClose, onSignUp, onSignupSuccess }) => {
  console.log('SignUp 컴포넌트 props:', {
    hasOnSignUp: !!onSignUp,
    onSignUpType: typeof onSignUp
  });

  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    name: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    setError(''); // 입력이 변경되면 에러 메시지 초기화
  };

  const validateForm = () => {
    if (!formData.email || !formData.password || !formData.confirmPassword || !formData.name) {
      setError('모든 필드를 입력해주세요.');
      return false;
    }
    if (formData.password !== formData.confirmPassword) {
      setError('비밀번호가 일치하지 않습니다.');
      return false;
    }
    if (formData.password.length < 6) {
      setError('비밀번호는 최소 6자 이상이어야 합니다.');
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    setError(''); // 에러 메시지 초기화
    
    try {
      console.log('회원가입 시도 - onSignUp 함수 타입:', typeof onSignUp);
      console.log('회원가입 전달 데이터:', formData);
      
      if (typeof onSignUp !== 'function') {
        throw new Error('회원가입 처리 함수가 올바르게 전달되지 않았습니다.');
      }
      
      const result = await onSignUp(formData);
      
      console.log('회원가입 응답 결과:', result);
      
      if (result.success) {
        console.log('회원가입 성공');
        // 성공 시 다이얼로그 닫기
        onClose();
        // 성공 메시지 표시 (옵션)
        if (onSignupSuccess) {
          onSignupSuccess();
        }
      } else {
        console.error('회원가입 실패:', result.error);
        setError(result.error);
      }
    } catch (error) {
      console.error('회원가입 처리 중 예외 발생:', error);
      setError('회원가입 처리 중 오류가 발생했습니다. ' + (error.message || ''));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={loading ? undefined : onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 2 }
      }}
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h5">회원가입</Typography>
          <IconButton 
            onClick={loading ? undefined : onClose}
            size="small"
            disabled={loading}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        {error && (
          <Alert 
            severity="error" 
            sx={{ 
              mb: 2,
              '& .MuiAlert-message': {
                whiteSpace: 'pre-line'
              }
            }}
          >
            {error}
          </Alert>
        )}
        <form onSubmit={handleSubmit}>
          <TextField
            autoFocus
            margin="dense"
            label="이름"
            type="text"
            fullWidth
            name="name"
            value={formData.name}
            onChange={handleChange}
            variant="outlined"
            sx={{ mb: 2 }}
          />
          <TextField
            margin="dense"
            label="이메일"
            type="email"
            fullWidth
            name="email"
            value={formData.email}
            onChange={handleChange}
            variant="outlined"
            sx={{ mb: 2 }}
          />
          <TextField
            margin="dense"
            label="비밀번호"
            type="password"
            fullWidth
            name="password"
            value={formData.password}
            onChange={handleChange}
            variant="outlined"
            sx={{ mb: 2 }}
            helperText="비밀번호는 최소 6자 이상이어야 합니다"
          />
          <TextField
            margin="dense"
            label="비밀번호 확인"
            type="password"
            fullWidth
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
            variant="outlined"
          />
          <DialogActions sx={{ px: 0, pb: 0, mt: 3 }}>
            <Button 
              onClick={onClose} 
              color="inherit"
              disabled={loading}
            >
              취소
            </Button>
            <Button 
              type="submit" 
              variant="contained"
              disabled={loading}
              sx={{ minWidth: 100 }}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                '가입하기'
              )}
            </Button>
          </DialogActions>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default SignUp;